import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import { API_HOST, axiosInstance, axiosRequestWithAuth } from './../../constants/server.constant';
import CommonMessage from './../common/commonMessage';

class LinkingCode extends Component {

    constructor(props) {
        super(props);
        this.state = {
            referralCode: "",
            userId: localStorage.getItem("userId"),
            message: "",
            msgType: "",
            referralCode: "https://www.idrivecompute.com/app/signup?tag=",
            isAction: false,
            totalCommision: 0,
            totalUsers: 0
        };

        this.copyLinkingCode = this.copyLinkingCode.bind(this);

        this.getReferralCode = this.getReferralCode.bind(this);
    }

    componentDidMount = () => {
        window.scrollTo(0, 0);
        this.getReferralCode();
    };

    getReferralCode = () => {
        this.setState({
            isAction: true
        });
        axiosInstance.get(API_HOST + "/referral/generate/" + this.state.userId, axiosRequestWithAuth)
            .then(resp => {
                resp = resp.data;
                if(resp === "FAILED_TO_GENERATE") {
                    this.setState({
                        isAction: false,
                        message: "Error while getting referral code, Please try again after sometime.",
                        msgType: "error"

                    });
                    return;
                }
                this.setState({
                    referralCode: this.state.referralCode + resp,
                    message: "",
                    msgType: ""
                });
                this.getTotalCommision();

            }).catch(err => {
                this.setState({
                    isAction: false,
                    message: "Error while getting referral code, Please try again after sometime.",
                    msgType: "error"

                });
                return;
            });

    };

    getTotalCommision = () => {
        axiosInstance.get(API_HOST + "/referral/getrefrralusers/" + this.state.userId, axiosRequestWithAuth)
            .then(resp => {
                resp = resp.data;
                let totalUsers = resp.length;
                let totalCredits = 0;

                for(let i = 0; i < resp.length; i++) {
                    totalCredits += Number(resp[i].credits);

                }

                this.setState({
                    isAction: false,
                    totalCommision: totalCredits / 100,
                    totalUsers: totalUsers
                });
            })
            .catch(error => {
                this.setState({
                    isAction: false
                });
            });
    };

    copyLinkingCode = (event, text) => {
        this.setState({
            isCopied: true
        });
        var textField = document.createElement('textarea');
        textField.innerText = text;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        textField.remove();
        setTimeout(() => {
            this.setState({
                isCopied: false
            });
        }, 2000);


    };

    render() {
        return (
            <React.Fragment>
                <div className="full_page_loader" style={ { display: this.state.isAction ? 'block' : 'none' } }>
                    <div className="loader_icon"></div>
                </div>
                <section className="referralModule_wrapper">
                    <div className="referral_section">
                        <div className="referal_program full_wid">
                            <h2 className="ref_heading">Refer IDrive<sup>®</sup> Compute and earn a one-time  commission</h2>
                            <p className="ref_para">Get paid <span className="amt_highlight">$10</span> for every sign-up via your referral when the user creates an instance.</p>
                            <div className="referal_bx">
                                <p className="ref_link"><span className="fnt-bld">Referral Link - </span> Copy and share this unique link with users</p>
                                <div className="txtBox_wrap">
                                    <input type="text" name="referal_link" id="size" className="txt_box" autocomplete="chrome-off" value={ this.state.referralCode } disabled />
                                    <span class="linkCopied" style={ { display: this.state.isCopied ? "" : "none" } }>Link Copied</span>
                                    <span className="cpy_link" data-for="copyLink" data-tip onClick={ (e) => this.copyLinkingCode(e, this.state.referralCode) }>
                                        <svg viewBox="0 0 22 25" enableBackground="new 0 0 22 25;" xmlSpace="preserve" >
                                            <g>
                                                <path className="cpy12" d="M18.5,22.5h-12c-0.6,0-1-0.4-1-1V6.4c0-0.6,0.4-1,1-1h12c0.6,0,1,0.4,1,1v15.1C19.5,22.1,19.1,22.5,18.5,22.5   z"></path>
                                                <path className="cpy11" d="M2.5,18.2V3.5c0-0.6,0.4-1,1-1h12.9"></path>
                                            </g>
                                        </svg>
                                    </span><ReactTooltip id="copyLink" effect='solid' place='top'>Copy Link</ReactTooltip>
                                </div>
                            </div>
                            <div className="link_desc">
                                <div className="link_desc_list">
                                    <p className="link_desc_li"><span className="check_icons"></span><span className="desc_txt">
                                        Share the unique referral link with your friends and contacts. All referrals must sign up using this link.</span></p>
                                    <p className="link_desc_li"><span className="check_icons"></span><span className="desc_txt">Referred user accounts must remain active for at least 30 days and must incur a charge on their account for instance creation.
                                    </span></p>
                                    <p className="link_desc_li" style={ { display: "none" } }><span className="check_icons"></span><span className="desc_txt">The commission will be paid immediately for prepaid yearly or monthly instance creation and after 30 days for postpaid monthly instance creation.
                                    </span></p>
                                </div>
                            </div>
                        </div>
                        <div class="linkWidget_ctnr">
                            <div class="img_wrp">
                                <span class="ref_icon"></span>
                            </div>
                            <div class="linkWidget wdgt_commission">
                                <div class="widCont">
                                    <h6>Commissions</h6>
                                    <span>${ this.state.totalCommision.toFixed(2) }</span>
                                </div>
                                <div class="widIco"></div>
                            </div>
                            <div class="linkWidget wdgt_users">
                                <div class="widCont">
                                    <h6>Referred Users</h6>
                                    <span>{ this.state.totalUsers < 10 ? "0" + this.state.totalUsers : this.state.totalUsers }</span>
                                </div>
                                <div class="widIco"></div>
                            </div>
                        </div>
                    </div>
                    <CommonMessage message={ this.state.message } msgType={ this.state.msgType } handler={ () => this.setState({ message: "" }) } />
                </section>

            </React.Fragment>
        );
    }

}
export default LinkingCode;
